import classnames from 'classnames';
import { PropsWithClassName } from 'lib-shared-types-utils';
import { Children, isValidElement, PropsWithChildren, ReactNode } from 'react';

import { Content } from './content';
import { Header } from './header';
import styles from './teamCard.module.scss';

type TeamCardProps = PropsWithChildren<
  {
    isOpen: boolean;
  } & PropsWithClassName
>;

const filterChildByDisplayName = (
  children: ReactNode,
  displayName: string,
): ReactNode =>
  Children.map(children, (child) => {
    if (
      isValidElement(child) &&
      typeof child.type !== 'string' &&
      'displayName' in child.type &&
      child.type.displayName === displayName
    ) {
      return child;
    }
    return null;
  });

const TeamCardComponent = ({
  className,
  isOpen,
  children,
}: TeamCardProps): JSX.Element => {
  const rootClass = classnames(
    {
      [styles.cardTeam]: true,
      [styles.cardTeamOpen]: isOpen,
    },
    className,
  );

  const header = filterChildByDisplayName(children, 'Header');
  const content = filterChildByDisplayName(children, 'Content');

  return (
    <div className={rootClass}>
      {header}
      {content}
    </div>
  );
};

const TeamCard = Object.assign(TeamCardComponent, {
  Header,
  Content,
});

export { TeamCard };
